import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MgService } from 'src/app/services/mg.service';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-filter-call',
  templateUrl: './filter-call.component.html',
  styleUrls: ['./filter-call.component.scss'],
})
export class FilterCallComponent implements OnInit {
  @Output() search: EventEmitter<any> = new EventEmitter();

  public operator = new UntypedFormControl();
  public business = new UntypedFormControl();
  public businessUser = new UntypedFormControl();
  public range = new UntypedFormGroup({
    start: new UntypedFormControl(),
    end: new UntypedFormControl()
  });

  public options: any = {};
  public searchControl = new UntypedFormControl();
  public modelChanged: Subject<string> = new Subject<string>();

  constructor(
    private api: MgService
  ) {
    this.modelChanged.pipe(
      debounceTime(1000),
      distinctUntilChanged())
      .subscribe(
        model => {
          let text = this.searchControl.value.replace(/\s/g, '+');
          this.makeSearch(text);
        }
      )
  }

  ngOnInit(): void {
    this.api.listFilterCallDetails()
      .subscribe(
        res => {
          this.options = res;
        }
      );
  }

  get operators(): any[] {
    return this.options.operators;
  }

  get businesses(): any[] {
    return this.options.businesses;
  }

  get businessUsers(): any[] {
    let businessUsers =  this.options.businessUsers

    if(!businessUsers) return;

    businessUsers = businessUsers.filter(item => {
      if(this.business.value) {
        return item.business_id == this.business.value;
      }
      return true;
    });

    return businessUsers;
  }

  public makeSearch(text?: string) {
    this.search.emit({
      operator: this.operator.value,
      business: this.business.value,
      businessUser: this.businessUser.value,
      range: this.range.value,
      text: text
    })
  }

  public searchItems(value){
    this.modelChanged.next(value);
  }

  public cleanFilter() {
    this.operator.setValue(null);
    this.business.setValue(null);
    this.businessUser.setValue(null);
    this.range.get('start').setValue(null);
    this.range.get('end').setValue(null);
    this.searchControl.setValue(null);
  }
}
